import React from 'react';
import PropTypes from 'prop-types';
import 'reset-css/reset.css';
import '../color/color';
import '../typography/typography';
import './blockquote.css';

const Blockquote = ({ text }) => <blockquote>{text}</blockquote>;

Blockquote.defaultProps = {
  text: '',
};

Blockquote.propTypes = {
  text: PropTypes.string,
};

export default Blockquote;
